module.exports = __webpack_public_path__ + "statics/img/1.9c0ff42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inRegard/1.png
// module id = bAKD
// module chunks = 1